module.exports = __webpack_public_path__ + "static/img/t-default-bg.fccc4aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/album/plugins/t-default-bg.png
// module id = 1332
// module chunks = 191